import { Component, OnInit } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { SubscriptionService } from "src/app/core/service/subscription.service";
import { SessionTO } from "src/app/data/schema/Identity/SessionTO";
import { SubscriptionDTO } from "src/app/data/schema/Subscriptions/SubscriptionDTO";
import { ApiInviteService } from "src/app/data/service/identity/api-invite.service";
import { IdentityRegisterDialogComponent } from "src/app/shared/component/identity-register-dialog/identity-register-dialog.component";

@Component({
    selector: "app-registrar-via-invite",
    templateUrl: "./registrar-via-invite.component.html",
    styleUrls: ["./registrar-via-invite.component.scss"]
})
export class RegistrarViaInviteComponent implements OnInit {
    subscription: SubscriptionDTO;
    sId: string;
    token: string;
    validInvite: boolean;

    constructor(
        private subscriptionService: SubscriptionService,
        private inviteService: ApiInviteService,
        private router: Router,
        public matDialog: MatDialog,
        private spinnerService: NgxSpinnerService
    ) {
        this.sId = null;
        this.token = null;
    }

    ngOnInit(): void {
        this.sId = this.getQueryParameter("sid");
        this.token = this.getQueryParameter("token");

        this.subscriptionService.setCurrentSubscriptionId(this.getQueryParameter("sid"));
        this.subscriptionService.currentSubscriptionAsync().subscribe((sub) => (this.subscription = sub));

        this.checkInvitation();
    }

    getQueryParameter(key: string): string {
        const parameters = new URLSearchParams(window.location.search);
        return parameters.get(key);
    }

    checkInvitation(): void {
        this.spinnerService.show("invite");

        this.inviteService.verificarInvite(this.sId, this.token).subscribe(
            (user) => {
                this.spinnerService.hide("invite");

                this.validInvite = true;

                const dialogConfig = new MatDialogConfig();
                dialogConfig.disableClose = true;

                dialogConfig.data = {
                    origin: "Invite",
                    userEmail: user.email,
                    disableClose: true,
                    tokenInvite: this.token,
                    groups: user.groups
                };

                const dialogRef = this.matDialog.open(IdentityRegisterDialogComponent, dialogConfig);

                dialogRef.afterClosed().subscribe((data: SessionTO) => {
                    if (!data) return;

                    this.spinnerService.hide("invite");
                    this.router.navigate(["/home"]);
                });
            },
            () => {
                this.spinnerService.hide("invite");
                this.validInvite = false;
            }
        );
    }
}
